module.exports = __webpack_public_path__ + "static/media/0801_PowerWash.de5a77f3.JPG";